import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { PRE_SALE_DROPDOWN, CREATE_PRE_SALE_SUPPLY ,GET_BLOCKED_DATA,UPDATE_BLOCKED_USER} from "./type";

export const getDropDownValues = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.preSalesSupply.dropDownList}?lead_id=${leadId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: PRE_SALE_DROPDOWN, payload: data.response.data });
    return true;
  }
};

export const savePresalesSupply = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.preSalesSupply.create
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: CREATE_PRE_SALE_SUPPLY, payload: data.response.data });
    return true;
  }
};

export const getBlockedData = (data) => async (dispatch) => {
  const days_filter=data?.days_filter??null;
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesSupply.getBlockedUserData}?days_filter=${days_filter}`
  );
  // V2 Go envelope: status===0; interceptor also mirrors into response.status===true.
  if (
    res?.data?.status === 0 ||
    res?.data?.status_code === 200 ||
    res?.data?.response?.status === true
  ) {
    const { data } = res;
    dispatch({
      type: GET_BLOCKED_DATA,
      payload: data.response?.data ?? data.data,
    });
    return true;
  }
};

export const updateUserStatus = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.patch,
    '',
    `${Config.preSalesSupply.updateUserBlockStatus}?user_id=${id}`
  );
  // V2 Go envelope: status===0; interceptor also mirrors into response.status===true.
  if (
    res?.data?.status === 0 ||
    res?.data?.status_code === 200 ||
    res?.data?.response?.status === true
  ) {
    const { data } = res;
    dispatch({
      type: UPDATE_BLOCKED_USER,
      payload: data.response?.data ?? data.data,
    });
    return true;
  }
};
